<template>
<div class="nebPillSelect">
  <pill v-for="opt in options"
    :key="opt.value"
    :label="opt.label"
    :value="opt.value"
    :isSelected="value === opt.value"
    :isNotSelected="value !== null && value !== opt.value"
    :color="opt.color || null"
    @click="onPillClick"
  />
</div>
</template>

<script>
import Pill from './Pill'

export default {
  name: 'NebPillSelect',

  components: {
    Pill
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  methods: {
    onPillClick (value) {
      if (value === this.value) {
        this.$emit('input', null)
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
.nebPillSelect {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
